import { FlightClass } from '@shared/base-search-bar/entities/flight-class';
import { PassengerType } from '@shared/base-search-bar/entities/passenger-arrangement';
import { SearchDataPassengers } from '@shared/base-search-bar/entities/search-data-passengers';

export const SEARCH_DATA_PASSENGERS = 'search_data_passengers';

export const DEFAULT_SEARCH_DATA_PASSENGERS: SearchDataPassengers = {
  guestsPerRoom: [{ ADULTS: 2, CHILDREN: 0, childrenAges: [], id: 0 }],
  guestsPerRoomState: {
    entities: {
      0: { id: 0, ADULTS: 2, CHILDREN: 0, childrenAges: Array(0) }
    },
    ids: [0]
  },
  passengerArrangement: [
    { id: PassengerType.ADULTS, quantity: 1 }, { id: PassengerType.CHILDREN, quantity: 0 },
    { id: PassengerType.INFANTS, quantity: 0 }],
  passengerArrangementsState: {
    ids: ['ADULTS', 'CHILDREN', 'INFANTS'],
    entities: {
      ADULTS: { id: PassengerType.ADULTS, quantity: 1 },
      CHILDREN: { id: PassengerType.CHILDREN, quantity: 0 },
      INFANTS: { id: PassengerType.INFANTS, quantity: 0 }
    }
  },
  flightClass: FlightClass.CHEAPER
}

